import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

// Stil dosyaları
import "index.css";
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.5.0";
import "assets/demo/demo.css?v=1.5.0";
import "assets/demo/react-demo.css?v=1.5.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.5.0";

// Sayfalar
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Blog from "./pages/Blog";
import Videolar from "./pages/Videolar";
import Lawyer from "pages/Lawyer";
import LawyerDetail from "pages/LawyerDetail";

// Özel Hukuk
import SozlesmelerVeBorclarHukuku from "./pages/SozlesmelerVeBorclarHukuku";
import IsHukuku from "./pages/IsHukuku";
import AileHukuku from "./pages/AileHukuku";
import MirasHukuku from "./pages/MirasHukuku";
import GayrimenkulHukuku from "./pages/GayrimenkulHukuku";

// Kamu Hukuku
import CezaHukuku from "./pages/CezaHukuku";
import IdareHukuku from "./pages/IdareHukuku";
import VergiHukuku from "./pages/VergiHukuku";
import GumrukHukuku from "./pages/GumrukHukuku";
import VatandaslikHukuku from "./pages/VatandaslikHukuku";

// Ticaret Hukuku
import TicaretHukuku from "./pages/TicaretHukuku";
import DenizTicaretiHukuku from "./pages/DenizTicaretiHukuku";
import RekabetHukuku from "./pages/RekabetHukuku";
import FikriMulkiyetHukuku from "./pages/FikriMulkiyetHukuku";
import IcraIflasHukuku from "pages/IcraIflasHukuku";

// Tüketici ve Sağlık Hukuku
import SaglikHukuku from "./pages/SaglikHukuku";
import TuketiciHukuku from "./pages/TuketiciHukuku";
import SigortaHukuku from "./pages/SigortaHukuku";
import SporHukuku from "pages/SporHukuku";

// Teknoloji ve Verilerin Korunması Hukuku
import BilisimHukuku from "./pages/BilisimHukuku";
import KisiselVerileriKorumaKanunu from "./pages/KisiselVerileriKorumaKanunu";

import BlogRouter from "components/Blog/BlogRouter";

// Kvkk Çerez Politikası ve Açık Rıza
import Kvkk from "pages/Kvkk";
import CerezPolitikasi from "pages/CerezPolitikası";
import AcikRiza from "pages/AcikRiza";

// Çerezler
import { CookieConsentProvider } from "components/CookieConsent/CookieConsentProvider";
import CookieBanner from "components/CookieConsent/CookieBanner";

// PrimeReact
import "primeicons/primeicons.css";
import { PrimeReactProvider } from "primereact/api";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";

// HelmetProvider
import { Helmet, HelmetProvider } from "react-helmet-async";

// SizeProvider
import { SizeProvider } from "components/SizeControl/SizeControl";
import Faaliyetlerimiz from "pages/Faaliyetlerimiz";
import FaaliyetDetail from "pages/FaaliyetDetail";
import PhotoGallery from "pages/PhotoGallery";
import Galerimiz from "pages/Galerimiz";

// Güvenli yönlendirme bileşeni
const NoIndexPage = () => (
  <Helmet>
    <meta name="robots" content="noindex, nofollow" />
  </Helmet>
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <PrimeReactProvider>
    <SizeProvider>
      <HelmetProvider>
        <CookieConsentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hakkimizda" element={<AboutUs />} />
              <Route path="/faaliyetlerimiz" element={<Faaliyetlerimiz />} />
              <Route path="/faaliyet/:id" element={<FaaliyetDetail />} />
              <Route path="/iletisim" element={<ContactUs />} />
              <Route path="/ekibimiz" element={<Lawyer />} />
              <Route path="/ekibimiz/:id" element={<LawyerDetail />} />
              {/* <Route path="/fotograflar" element={<PhotoGallery />} /> */}

              <Route
                path="/ozel-hukuk/sozlesmeler-ve-borclar-hukuku"
                element={<SozlesmelerVeBorclarHukuku />}
              />
              <Route path="/ozel-hukuk/aile-hukuku" element={<AileHukuku />} />
              <Route
                path="/ozel-hukuk/miras-hukuku"
                element={<MirasHukuku />}
              />
              <Route
                path="/ozel-hukuk/ticaret-hukuku"
                element={<TicaretHukuku />}
              />
              <Route
                path="/ozel-hukuk/gayrimenkul-hukuku"
                element={<GayrimenkulHukuku />}
              />

              <Route path="/kamu-hukuku/ceza-hukuku" element={<CezaHukuku />} />
              <Route
                path="/kamu-hukuku/idare-hukuku"
                element={<IdareHukuku />}
              />
              <Route
                path="/kamu-hukuku/vergi-hukuku"
                element={<VergiHukuku />}
              />
              <Route
                path="/kamu-hukuku/gumruk-hukuku"
                element={<GumrukHukuku />}
              />
              <Route
                path="/kamu-hukuku/vatandaslik-hukuku"
                element={<VatandaslikHukuku />}
              />

              <Route
                path="/ekonomi-ve-ticaret-hukuku/icra-iflas-hukuku"
                element={<IcraIflasHukuku />}
              />
              <Route
                path="/ekonomi-ve-ticaret-hukuku/deniz-ticareti-hukuku"
                element={<DenizTicaretiHukuku />}
              />
              <Route
                path="/ekonomi-ve-ticaret-hukuku/rekabet-hukuku"
                element={<RekabetHukuku />}
              />
              <Route
                path="/ekonomi-ve-ticaret-hukuku/fikri-mulkiyet-hukuku"
                element={<FikriMulkiyetHukuku />}
              />

              <Route
                path="/sosyal-ve-idari-hukuk/is-ve-sosyal-guvenlik-hukuku"
                element={<IsHukuku />}
              />
              <Route
                path="/sosyal-ve-idari-hukuk/tuketici-hukuku"
                element={<TuketiciHukuku />}
              />
              <Route
                path="/sosyal-ve-idari-hukuk/saglik-hukuku"
                element={<SaglikHukuku />}
              />
              <Route
                path="/sosyal-ve-idari-hukuk/spor-hukuku"
                element={<SporHukuku />}
              />

              <Route
                path="/sigorta-tahkim-hukuku"
                element={<SigortaHukuku />}
              />
              <Route
                path="/teknoloji-ve-internet-hukuku/bilisim-hukuku"
                element={<BilisimHukuku />}
              />
              <Route
                path="/teknoloji-ve-internet-hukuku/kisisel-verilerin-korunmasi-hukuku"
                element={<KisiselVerileriKorumaKanunu />}
              />
              <Route
                path="/teknoloji-ve-verilerin-korunmasi-hukuku/kisisel-verilerin-korunmasi-hukuku"
                element={
                  <Navigate
                    to="/teknoloji-ve-internet-hukuku/kisisel-verilerin-korunmasi-hukuku"
                    replace
                  />
                }
              />

              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/*" element={<BlogRouter />} />
              <Route path="/galeri" element={<Galerimiz />} />
              <Route path="/kvkk" element={<Kvkk />} />
              <Route path="/cerez-politikasi" element={<CerezPolitikasi />} />
              <Route path="/acik-riza-metni" element={<AcikRiza />} />

              {/* 🔹 Yönlendirme: /kurumsal-2 → hakkimizda */}
              <Route path="/kurumsal-2" element={<NoIndexPage />} />
              <Route path="/avukatlarimiz" element={<NoIndexPage />} />
              {<Route path="/ekibimiz" element={<NoIndexPage />} />}
              <Route path="/332-2" element={<NoIndexPage />} />
              <Route
                path="/olumlu-trafik-kazasi-tazminat"
                element={<NoIndexPage />}
              />
              <Route path="/kusur-orani-hesapla" element={<NoIndexPage />} />
              <Route path="/hizmetlerimiz" element={<NoIndexPage />} />
              <Route path="/deger-kaybi-hesaplama" element={<NoIndexPage />} />
              <Route
                path="/maddi-hasarli-trafik-kazasi-tazminati"
                element={<NoIndexPage />}
              />
              <Route path="/__trashed" element={<NoIndexPage />} />

              {/* 404 yönlendirme */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
        </CookieConsentProvider>
      </HelmetProvider>
    </SizeProvider>
  </PrimeReactProvider>,
);
